import styled from 'styled-components'

export const SkillsContainer = styled.div`
    height: 720px;
    text-align: center; 
    padding: 150px 0px 0px 0px;

    @media screen and (max-width: 768px){
        height: 850px;
    }
`;

export const SkillsWrapper = styled.div``;

export const SkillsWrap = styled.div`

    width: 75%;
    margin: 0 auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

`;

export const SkillsUl = styled.ul`

    &:after {
            content: "";
            clear: both;
            display: table;
    }

    margin: 10px;
    margin-left: 2px;
    display: block;
    -webkit-box-shadow: 0px 100px 70px -80px rgba(0, 0, 0, 0.55);
    box-shadow: 0px 100px 70px -80px rgba(0, 0, 0, 0.55);
    -webkit-box-shadow: 0px 100px 70px -80px rgba(0, 0, 0, 0.85);
    box-shadow: 0px 100px 70px -80px rgba(0, 0, 0, 0.85);

`;

export const SkillsImg = styled.img`
    opacity: 0.3;
    transition: all 0.2s ease 0s;
    -webkit-transition: all 0.2s ease 0s;
    width: 30%;
    height: 50%;
    margin: 7%;

`;

export const SkillsH1 = styled.h1` margin-bottom: 50px; font-size:2.5rem; `;

export const SkillsLi = styled.li`
display: block;
float: left;
width: 25%;
min-height: 30px;
border: 1px solid #ddd;
border-radius: 25px;
-webkit-box-sizing: border-box;
box-sizing: border-box;
text-align: center;
opacity: 1;

@media screen and (max-width: 768px){
    float: right;
    width: 45%; 
}

    
    &:hover ${SkillsImg} {
    transition: all 0.2s ease-in-out;
    opacity: 1;
}

`;

export const SkillsAntiBug = styled.div``;


